const buttonForgotPassConfirm = {
  text: 'Change Password'
};

export default buttonForgotPassConfirm;
